<div class="inventory-item-wrapper" [ngClass]="{'not-tradable': !tradable}">
  <div class="market-item-in">
    <div class="inventory-item-exterior">{{exterior}}
      <span *ngIf="exterior">({{getItemExterior(exterior) }})</span>
    </div>
    <app-count-down *ngIf="nextStatusAt" [nextStatusAt]="nextStatusAt"></app-count-down>
  </div>
  <div class="market-item-image">
    <img [src]="weapon | hash" [alt]="name">
  </div>
  <div class="market-item-info">
    <div class="market-item-wrapper">
      <div class="skin-name text-overflow"
           matTooltip="{{name}} | {{skin}}"
           matTooltipPosition="above">
        <span class="stat-trak" *ngIf="statTrak">StatTrak™ </span>
        <span class="inventory-item-name">{{ name }} </span>
        <span class="inventory-item-rarity" *ngIf="skin">| {{ skin }}</span>
      </div>
      <div class="price">
        <span class="field">цена:</span>
        <span
          matTooltip="{{price | fastCoinsToDollar}}"
          matTooltipPosition="above"
          [matTooltipDisabled]="!isGoFast"
        >{{price / 100 | customCurrency}}</span>
      </div>
      <div class="price" *ngIf="sellerPrice">
        <span class="field">цена юзера:</span>
        <span
          matTooltip="{{sellerPrice | fastCoinsToDollar}}"
          matTooltipPosition="above"
          [matTooltipDisabled]="!isGoFast">
          {{sellerPrice / 100}} ({{(sellerPrice * 100 / price) - 100 | ceil }}%)
        </span>
      </div>
      <div class="price" *ngIf="recommendedPrice">
        <span class="field">рекоммендованная:</span>
        <span
          matTooltip="{{recommendedPrice | fastCoinsToDollar}}"
          matTooltipPosition="above"
          [matTooltipDisabled]="!isGoFast"
        >{{recommendedPrice / 100 | customCurrency}}</span>
      </div>
      <div *ngIf="phase">
        <span class="field">phase: </span>
        {{phase}}</div>
      <div *ngIf="status">
        <span class="field">status: </span>
        {{status}}</div>
    </div>
  </div>
</div>
